import React from 'react'
import axios from 'axios'

import './LoginJuridico.css'
import brasao from '../../assets/brasil.jpeg'
import mbtech from '../../assets/mbtech.svg'
import jurisPro from '../../assets/jurisPro.png'

const initialState = {
    user: {
        matricula: '',
        password: ''
    }
}

export default class LoginJuridico extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...initialState }
    }

    updateField(event) {
        const user = { ...this.state.user }
        user[event.target.name] = event.target.value
        this.setState({ user })
    }

    login() { 
        const url = '/api/authJuridico'
        const user = { ...this.state.user }
        axios.post(url, user)
            .then(res => {
                const { token, payload } = res.data
                localStorage.setItem('tokenJ', token)
                localStorage.setItem('idJ', payload.user.id)
                localStorage.setItem('nomeJ', payload.user.nome)
                localStorage.setItem('matriculaJ', payload.user.matricula)
                localStorage.setItem('tipoJ', payload.user.tipo)
                
                return window.location = "/juridico"
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            });
    }

    render() {
        return (
            <React.Fragment>
                <div className="mx-auto quadrado">
                    <div className="form">
                        <img src={brasao} alt="Brasil" className='brasao' />

                        <label className='label label1'>Usuário</label>
                        <input type="text" className='inputField'
                            name="matricula"
                            value={this.state.matricula}
                            onChange={e => this.updateField(e)} />

                        <label className='label label2'>Senha</label>
                        <input type="password" className='inputField'
                            name="password"
                            value={this.state.password}
                            onChange={e => this.updateField(e)} />

                        <button className='botaoEntrar' onClick={e => this.login()}>Entrar</button>
                    </div>
                    <img src={jurisPro} alt="jurisPro" className='jurisPro' />
                    <img src={mbtech} alt="mbtech" className='mbtech' />
                </div>
            </React.Fragment>
        )
    }
}